import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { CheckCircle, AlertTriangle, XCircle } from "lucide-react";

interface SLAMetric {
  category: string;
  target: number;
  current: number;
  total: number;
  onTime: number;
  breached: number;
}

interface SLAPerformanceCardProps {
  slaMetrics: SLAMetric[];
}

export const SLAPerformanceCard = ({ slaMetrics }: SLAPerformanceCardProps) => {
  const getSLAColor = (performance: number) => {
    if (performance >= 90) return "text-green-600 dark:text-green-400";
    if (performance >= 75) return "text-yellow-600 dark:text-yellow-400";
    return "text-red-600 dark:text-red-400";
  };

  const getSLAIcon = (performance: number) => {
    if (performance >= 90) return <CheckCircle className="h-5 w-5 text-green-600 dark:text-green-400" />;
    if (performance >= 75) return <AlertTriangle className="h-5 w-5 text-yellow-600 dark:text-yellow-400" />;
    return <XCircle className="h-5 w-5 text-red-600 dark:text-red-400" />;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Performance de SLA</CardTitle>
        <CardDescription>Cumprimento de prazos por categoria</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        {slaMetrics?.map((metric) => (
          <div key={metric.category} className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                {getSLAIcon(metric.current)}
                <span className="font-medium">{metric.category}</span>
              </div>
              <div className="flex items-center gap-4">
                <span className={`text-2xl font-bold ${getSLAColor(metric.current)}`}>
                  {metric.current.toFixed(1)}%
                </span>
                <Badge variant="outline" className="text-xs">
                  Meta: {metric.target}%
                </Badge>
              </div>
            </div>
            
            <Progress 
              value={metric.current} 
              className={metric.current >= 90 ? "bg-green-100 dark:bg-green-900/20" : 
                        metric.current >= 75 ? "bg-yellow-100 dark:bg-yellow-900/20" : 
                        "bg-red-100 dark:bg-red-900/20"}
            />
            
            <div className="flex justify-between text-xs text-muted-foreground">
              <span className="flex items-center gap-1">
                <span className="w-2 h-2 rounded-full bg-green-500"></span>
                No prazo: {metric.onTime}
              </span>
              <span className="flex items-center gap-1">
                <span className="w-2 h-2 rounded-full bg-red-500"></span>
                Violados: {metric.breached}
              </span>
              <span>Total: {metric.total}</span>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
